// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkuBundleImages_images__3NGpw {
  display: flex;
  gap: 1.1rem;
  align-items: flex-start;
}

.SkuBundleImages_images__list__50lsh {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}

.SkuBundleImages_images__list-item__3EYnc {
  border: 1px solid var(--black-ten-opacity);
  border-radius: 1rem;
  width: 11.7rem;
  height: 11.7rem;
}

.SkuBundleImages_images__list-item--active__AbEBm {
  border-color: var(--primary-color);
}

.SkuBundleImages_images__list-item-btn__mGv0U {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.SkuBundleImages_images__list-item-img__NFrK2 {
  width: 7rem;
  height: 7rem;
  object-fit: contain;
}

.SkuBundleImages_images__current-img-wrapper__r2aMI {
  width: 40rem;
  height: 40rem;
  padding: 1rem;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .SkuBundleImages_images__list-item__3EYnc {
    width: 10rem;
    height: 10rem;
  }

  .SkuBundleImages_images__current-img-wrapper__r2aMI {
    width: 30rem;
    height: 30rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SkuBundleDetails/SkuBundleImages/SkuBundleImages.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".images {\n  display: flex;\n  gap: 1.1rem;\n  align-items: flex-start;\n}\n\n.images__list {\n  display: flex;\n  flex-direction: column;\n  gap: 2.5rem;\n}\n\n.images__list-item {\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  width: 11.7rem;\n  height: 11.7rem;\n}\n\n.images__list-item--active {\n  border-color: var(--primary-color);\n}\n\n.images__list-item-btn {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.images__list-item-img {\n  width: 7rem;\n  height: 7rem;\n  object-fit: contain;\n}\n\n.images__current-img-wrapper {\n  width: 40rem;\n  height: 40rem;\n  padding: 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 1rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media screen and (min-width: 1024px) and (max-width: 1280px) {\n  .images__list-item {\n    width: 10rem;\n    height: 10rem;\n  }\n\n  .images__current-img-wrapper {\n    width: 30rem;\n    height: 30rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"images": `SkuBundleImages_images__3NGpw`,
	"images__list": `SkuBundleImages_images__list__50lsh`,
	"images__list-item": `SkuBundleImages_images__list-item__3EYnc`,
	"images__list-item--active": `SkuBundleImages_images__list-item--active__AbEBm`,
	"images__list-item-btn": `SkuBundleImages_images__list-item-btn__mGv0U`,
	"images__list-item-img": `SkuBundleImages_images__list-item-img__NFrK2`,
	"images__current-img-wrapper": `SkuBundleImages_images__current-img-wrapper__r2aMI`
};
export default ___CSS_LOADER_EXPORT___;
